import React from "react";
import {
    ToggleButton,
    ToggleButtonGroup,
    composeRenderProps,
} from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const Pill = (props: React.ComponentProps<typeof ToggleButton>) => (
    <ToggleButton
        {...props}
        className={composeRenderProps(props.className, (cn) =>
            concatClassNames([cn, styles.pill]),
        )}
    />
);

export const PillGroup = (
    props: React.ComponentProps<typeof ToggleButtonGroup>,
) => (
    <ToggleButtonGroup
        {...props}
        className={composeRenderProps(props.className, (cn) =>
            concatClassNames([cn, styles.pillGroup]),
        )}
    />
);
